/**
 * @file    registry.ts
 * @scope   ENGINE
 * @summary Registry of engine subtype plugins mounted by the drawer.
 * @produces ENGINE_PLUGINS, restoreEngineTrend
 * @sideEffects None.
 * @notes Order matters: providers nest and tab cleanups run in this order.
 *        A new subtype only needs to be appended here.
 */
import { TrendOptions } from 'core-ui/SelectTrendInput/SelectTrendInput';
import { enterprisePlugin } from './enterprise/enterprisePlugin';
import { cprPlugin } from './cpr/cprPlugin';
import { EngineSubtypePlugin } from './types';

export const ENGINE_PLUGINS: readonly EngineSubtypePlugin[] = [enterprisePlugin, cprPlugin];

/** First trend restored by any plugin, `undefined` when none applies. */
export const restoreEngineTrend = (
  options: TrendOptions[],
  config: any
): TrendOptions | undefined => {
  for (const plugin of ENGINE_PLUGINS) {
    const restored = plugin.restoreTrend?.(options, config);
    if (restored) return restored;
  }
  return undefined;
};
